module.exports = __webpack_public_path__ + "img/TECATELOGO.0072eedb.png";